document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.product-set-items');

  function getCurrentVariantId() {
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant && !isNaN(Number(urlVariant))) {
      return Number(urlVariant);
    }

    const selectors = [
      'main-product form[action*="/cart/add"] input[name="id"]',
      '.product-form form[action*="/cart/add"] input[name="id"]',
      'form[action*="/cart/add"] input[name="id"]',
      'main-product form[action*="/cart/add"] select[name="id"]',
      '.product-form form[action*="/cart/add"] select[name="id"]',
      'form[action*="/cart/add"] select[name="id"]',
      'input[name="id"][type="hidden"]',
      'select[name="id"]'
    ];

    for (const selector of selectors) {
      const el = document.querySelector(selector);
      if (el && el.value && !isNaN(Number(el.value))) {
        return Number(el.value);
      }
    }

    return null;
  }

  sections.forEach((section) => {
    const button = section.querySelector('[data-add-set-to-cart]');
    const message = section.querySelector('[data-set-cart-message]');
    const dataEl = section.querySelector('[data-set-items]');

    if (!button || !dataEl) return;

    button.addEventListener('click', async () => {
      let items = [];

      try {
        items = JSON.parse(dataEl.textContent.trim());
      } catch (error) {
        console.error('Invalid set JSON', error);
        if (message) {
          message.textContent = 'Грешка при зареждане на комплекта.';
        }
        return;
      }

      const currentVariantId = getCurrentVariantId();

      if (!currentVariantId) {
        console.error('Current variant not found');
        if (message) {
          message.textContent = 'Не е избран вариант на текущия продукт.';
        }
        return;
      }

      const hasCurrentAlready = items.some(
        (item) => Number(item.id) === Number(currentVariantId)
      );

      if (!hasCurrentAlready) {
        items.unshift({
          id: currentVariantId,
          quantity: 1
        });
      }

      button.disabled = true;
      button.classList.add('is-loading');

      if (message) {
        message.textContent = 'Добавяне в количката...';
      }

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || 'Неуспешно добавяне в количката.');
        }

        await response.json();
        window.location.href = window.Shopify.routes.root + 'cart';
      } catch (error) {
        console.error(error);
        if (message) {
          message.textContent = error.message || 'Възникна грешка.';
        }
      } finally {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    });
  });
});